import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Carousel } from "react-responsive-carousel";
import { GetAllCMSData, GetBannersData } from "../../../services/cmsService";
import {
  homePageDataSelector,
  setHomeBannersError,
  sethomeBannersData,
} from "../../../redux/homepage";
import ApiConfig from "../../../config/ApiConfig";
import { useNavigate } from "react-router-dom";
import {
  CMSDataSelector,
  setHomeData,
  setHomeDataError,
} from "../../../redux/cmsData";

function CarouselComponent() {
  const navigate = useNavigate();
  const { loading, homeBanners } = useSelector(homePageDataSelector);
  const dispatch = useDispatch();
  const { HomePage } = useSelector(CMSDataSelector);
  const [cmsDataHomePage, setCmsDatahomePage] = useState(null);

  const getCMSData = async () => {
    let payload = { pagename: "homePage" };
    dispatch(GetAllCMSData(payload, setHomeData, setHomeDataError));
  };
  useEffect(() => {
    getCMSData();
  }, []);

  useEffect(() => {
    let cmsDataHome = HomePage
      ? HomePage?.items?.length > 0 &&
        JSON?.parse(HomePage?.items[0]?.key_value)
      : [];
    setCmsDatahomePage(cmsDataHome);
  }, [HomePage]);

  const getBannersData = async () => {
    dispatch(GetBannersData(sethomeBannersData, setHomeBannersError));
  };

  useEffect(() => {
    getBannersData();
  }, []);

  const handleBannerClick = () => {
    //navigate(`/pricing`);
    // navigate(`/${cmsDataHomePage?.BannerLink?.bannerLink}`);
    navigate(`/${cmsDataHomePage.BannerLink.bannerLink}`, {
        state: { banerHeading: cmsDataHomePage.BannerLink.bannerHeading },
      });
  };

  return (
    <>
      {homeBanners?.items?.message && homeBanners?.items?.message.length > 1 ? (
        <Carousel
          autoPlay
          infiniteLoop
          showThumbs={false}
          swipeable={true}
          interval={5000}
          showStatus={false}
          transitionTime={0}
        >
          {homeBanners?.items?.message.map((item, index) => (
            <div
              key={`${item?.image_name}${index}`}
              onClick={() => handleBannerClick()}
              style={{ cursor: "pointer" }}
              r
            >
              <img
                className="homepage-hero-image"
                src={`${ApiConfig?.S3_BASE_URL}bannersImages/${item?.image_name}`}
                alt={`Banner ${index + 1}`}
              />
            </div>
          ))}
        </Carousel>
      ) : (
        homeBanners?.items?.message &&
        homeBanners?.items?.message.length > 0 && (
          <img
            src={`${ApiConfig?.S3_BASE_URL}bannersImages/${homeBanners?.items?.message[0]?.image_name}`}
            className="homepage-hero-image"
            alt="Image Of Banner"
            onClick={() => handleBannerClick()}
            style={{ cursor: "pointer" }}
          />
        )
      )}
    </>
  );
}

export default CarouselComponent;
